<template>
  <div>
    <AnalysisActions
      type="mission"
      @addNewElement="openCreationForm"
      :read-only="readOnly"
    >
      <template v-slot:input>
        <MissionCreationForm
          class="mr-10 mb-2"
          ref="missionCreationForm"
          @cancel="cancelCreationForm"
          @save="onSaveMissionCreationForm"
        />
      </template>
    </AnalysisActions>
    <Mission
      v-for="(mission, index) in missions"
      :key="`${mission.id}-mission`"
      :mission="mission"
      :index="index"
      :user-analysis-id="userAnalysis.id"
      :analysis-id="analysisId"
      class="mb-6 mr-10"
    />
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import { types as analysesTypes } from '../../../store/analyses';
import { types as missionsTypes } from '../../../store/missions';
import AnalysisActions from '../AnalysisActions';
import MissionCreationForm from './MissionCreationForm';
import Mission from './Mission';

export default {
  name: 'Missions',
  components: {
    AnalysisActions,
    MissionCreationForm,
    Mission,
  },
  props: {
    analysisId: {
      type: String,
      required: true,
    },
    userAnalysis: {
      type: Object,
      required: true,
    },
    readOnly: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      codeClassification: '',
    };
  },
  computed: {
    missions() {
      return this.userAnalysis.missions;
    },
  },
  methods: {
    ...mapActions({
      addUserAnalysisElement: analysesTypes.actions.addUserAnalysisElement,
      createMission: missionsTypes.actions.createMission,
    }),
    codeClassificationSelection(newClassification) {
      this.codeClassification = newClassification;
    },
    openCreationForm() {
      this.$refs.missionCreationForm.toggle();
      const { expanded } = this.$refs.missionCreationForm;
      if (expanded) {
        this.$nextTick(() => this.$refs.missionCreationForm.$refs.textInput.$refs.textArea.focus());
      }
    },
    onSaveMissionCreationForm({ text, selectedColleagues }) {
      this.$refs.missionCreationForm.toggle();
      this.createMission({
        text,
        selectedColleagues,
        codeClassification: this.codeClassification,
        userAnalysis: this.userAnalysis,
      });
    },
    cancelCreationForm() {
      console.log('cancel from mission.vue');
      this.$refs.missionCreationForm.toggle();
    },
  },
};
</script>
